import numeral from 'numeral';

export const KEYS_IMPRESSIONS = [
    {
        key: 'imp_index_D',
        label: 'Domain Impressions Index',
    },
    {
        key: 'imp_index_C',
        label: 'Competitive Impressions Index',
    },
];
export const KEYS_CLICKS = [
    {
        key: 'cl_index_D',
        label: 'Domain Clicks Index',
        format: '0.00%',
    },
    {
        key: 'cl_index_C',
        label: 'Competitive Clicks Index',
    },
];
export const KEYS_CTR = [
    {
        key: 'D_ctr',
        label: 'Domain CTR Index',
        render: (data) => numeral(data * 100).format('0.00'),
    },
    {
        key: 'C_ctr',
        label: 'Competitive CTR Index',
        render: (data) => numeral(data * 100).format('0.00'),
    },
];
